import * as React from 'react';
import { IEnvironment } from '../../../interfaces/IEnvironment';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAButton } from '../../button/Button';
import { IAMediaSelectorPreview } from '../mediaSelectorPreview/MediaSelectorPreview';
import { IATextField } from '../../textField/TextField';
import * as styles from "./MediaSelectorLink.css";

export interface IAMediaSelectorLinkProps {
  token: string;
  tenant: string;
  environment: IEnvironment;
  fileType: "image" | "video";
  highlightColor: string;
  onSelect: (url: string) => void;
}

export interface IAMediaSelectorLinkState {
  linkText: string;
}

export class IAMediaSelectorLink extends React.Component<IAMediaSelectorLinkProps, IAMediaSelectorLinkState> {
  private readonly localizationService = new LocalizationService();

  constructor(props: IAMediaSelectorLinkProps) {
    super(props);
    this.state = {
      linkText: undefined
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    return (
      <>
        <div className={styles.IA_MediaSelectorLinkContainer}>
          <IATextField
            text={this.state.linkText}
            label={this.localizationService.strings.Uploader_CopyPasteUrl}
            placeholder={this.localizationService.strings.Uploader_PasteUrl}
            onlyPaste
            onChange={(text) => this.setState({linkText: text})}
            borderRadius={5}
            highlightColor={this.props.highlightColor}
          />
          <IAButton
            label={this.localizationService.strings.MediaSelector_Use}
            borderRadius={5}
            buttonColor={this.props.highlightColor}
            onClick={() => this.props.onSelect(this.state.linkText)}
            style={{
              marginLeft: 10,
              height: 40,
              wordBreak: "normal"
            }}
          />
        </div>
        {this.state.linkText &&
          <IAMediaSelectorPreview
            tenant={this.props.tenant}
            token={this.props.token}
            environment={this.props.environment}
            fileType={this.props.fileType}
            highlightColor={this.props.highlightColor}
            onClearImage={undefined}
            url={this.state.linkText}
            style={{
              width: "calc(100% - 10px)",
              marginTop: 15
            }}
          />
        }
      </>
    );
  }
}
